import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbDate, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../services/data.service';
import { MeetingRoom, Availability, Time } from '../models/data.model';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-meeting-room-status',
  templateUrl: './meeting-room-status.component.html',
  styleUrls: ['./meeting-room-status.component.css']
})
export class MeetingRoomStatusComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal
    , private dataService: DataService
    , private roomService: CommonService<MeetingRoom>) { }

  interval = 60;

  selectedDate: NgbDate = new NgbDate(2019, 1, 1);
  time: NgbTimeStruct = { hour: 0, minute: 0, second: 0 };
  roomList: MeetingRoom[] = [];
  date: Date;

  TimeList: Time[] = [];
  FilteredTimeList: Time[] = [];

  selected = {
    startTime: { text: '', value: 0 },
    endTime: { text: '', value: 0 }
  }

  ngOnInit() {

      this.dataService.ComponentInput.subscribe(selectedDate => {
        this.date = selectedDate.date;
        this.time.hour = this.date.getHours();
        this.time.minute = this.date.getMinutes();
        this.selectedDate = new NgbDate(this.date.getFullYear(), this.date.getMonth() + 1, this.date.getDate());
        console.log('this is selected Date', this.selectedDate);
      });

      this.fillTimeList(this.interval).then(() => {
        this.fetchRoomList();
      });

  }

  fillTimeList = (interval) => {
    return new Promise(resolve => {
      let totalMin = 1440;//24 Hour in minute
      let loopCount = totalMin / interval;

      for (let i = 0; i < loopCount; i++) {
        let minuts = i * interval;
        let text = this.addZero(i) + ':00';
        this.TimeList.push({ text: text, value: minuts });
      }
      let startValue = this.date.getHours() * interval;
      let index = this.TimeList.findIndex(x => x.value == startValue)
      this.selected.startTime = this.TimeList[index];
      this.selected.endTime = this.TimeList[index + 1];
      this.filterEndTime(this.selected.startTime);
      resolve();
    });



  }

  filterEndTime = (startTime) => {
    this.selected.startTime = startTime;
    this.FilteredTimeList = this.TimeList.filter(x => x.value > startTime.value);
    this.selected.endTime = this.FilteredTimeList[0];
  }

  addZero = (digit) => {
    if (digit < 10)
      return '0' + digit;
    else
      return digit;
  }

  fetchRoomList = () => {
    this.roomService.getData('./assets/files/meetinRooms.json', {}, false).subscribe(result => {
      if (result != null) {
        this.roomList = result as MeetingRoom[];
        console.log('room list', this.roomList);
        this.fetchRoomStatus();
      }

    }, error => console.error(error));
  }

  fetchRoomStatus = () => {
    //let iniHour = this.selected.startTime.value / this.interval;
    let hourMin = this.selected.startTime.text.split(':');
    let hour = Number.parseInt(hourMin[0]);
    let min = Number.parseInt(hourMin[1]);
    let dateTime = new Date(this.selectedDate.year, this.selectedDate.month - 1, this.selectedDate.day, hour, min, 0, 0);
    let interval = this.selected.endTime.value - this.selected.startTime.value;
    this.roomList.forEach(room => {
      let url = 'api/rest/getMeetingRoomAvailibility';
      let params = { params: { room: room.address, interval: interval, dateTime: dateTime.getTime() } };

      //let params = { params: {room:'room.galileo@esaote.com',interval:interval,dateTime:dateTime.getTime()} };
      this.roomService.getData(url, params, false).subscribe(result => {
        if (result != null) {

          switch (result[0].availabilityView) {
            case "0":
              room.status = Availability.FREE;
              break;
            case "2":
              room.status = Availability.BUSY;
              break;
          }
          console.log('this is ' + room + 'status', result);

        }

      }, error => console.error(error));


    })
  }
}
